<template>
  <div class="banner">
    <div
      v-if="$config?.common?.newsflash"
      class="banner--news decors-background-bandeau-news-alerte-info"
    >
      {{ $config.common.newsflash }}
      <div class="after" />
    </div>
    <div class="banner--title">
      <div class="before decors-background-bandeau-news-background-coin-gauche" />
      <h2 class="decors-background-bandeau-news-background">
        {{ titleStr }}
      </h2>
      <div class="after decors-background-bandeau-news-coin-droit" />
    </div>
    <div class="banner--headlines">
      <div class="before decors-background-bandeau-news-heure-coin-gauche" />
      <time>{{ currentHour }}</time>
      <HeadlinesBanner
        class="banner--headlines--titles"
        :items="items"
      />
    </div>
  </div>
</template>

<script>
import HeadlinesBanner from '@/components/common/banner/HeadlinesBanner.vue';

export default {
  name: 'LowerThird',
  components: {
    HeadlinesBanner,
  },
  props: {
    title: {
      type: String,
      required: false,
      default: '',
    },
  },
  data() {
    return {
      currentHour: '',
    };
  },
  computed: {
    titleStr() {
      return this.title || this.$content.title;
    },
    items() {
      let hl = this.$content.headlines || this.$config.common.headlines || [];
      hl = hl.concat();
      if (this.$store.state.attributes?.headline && this.$store.state.attributes.headline !== '') {
        hl.unshift(this.$store.state.attributes.headline);
      }
      return hl;
    },
  },

  created() {
    this.updateTime();
    this.interval = setInterval(this.updateTime, 1000);
  },
  beforeDestroy() {
    clearInterval(this.interval);
  },
  methods: {
    updateTime() {
      const now = new Date();
      const options = { hour: '2-digit', minute: '2-digit' };
      let timeString = now.toLocaleTimeString(this.$lang, options);
      timeString = timeString.replace(':', 'H');
      this.currentHour = timeString;
    },
  },
};
</script>

<style lang="stylus" scoped>
.banner {
  --padding: 20px;
  width: 100%;
  text-transform: uppercase;
  font-size: 18px;
  letter-spacing: 2.76px;
  color: $cl-dark-blue
  padding-left var(--padding);
  max-width: calc(1512px - var(--padding));
  position: relative;
  overflow: hidden;
  width: calc(100% - var(--app-gutter));
  max-width: $container-width;

  +mobile(){
    max-width: 100%;
  }

  +desktop(){
    font-size: 2.3rem;
    letter-spacing: 0.2rem;
  }

  &--news {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    padding: 0 0 0 8px;
    font-size: 15px;
    +desktop(){
      justify-content: center;
      padding: 0 0 0 15px;
      font-size: 23px;
    }
  }

  &--title {
    display: flex;
    margin-left: 32px
    width: 100%;

    +mobile() {
      margin-left: 0;
      width: 100%;
    }

    div {
      flex-grow: 0;
      flex-shrink: 0;
      padding: 0;
      margin: 0;

      +mobile(){
        display: none;
      }

      &.after {
        margin-left: -90px
      }
    }

    h2 {
      display: flex;
      padding: 0;
      margin: 0;
      font-weight: bold;
      text-align: left;
      width: calc(100% - 32px)
      background-position: left center;
      color: white;
      align-items: center;
      justify-content: flex-start;
      background-color: #00022A
      // overflow: hidden;

      font-size: 3rem;
      padding: 0 10px 0 10px;
      +desktop() {
        white-space: nowrap;
        font-size: 4.8rem;
        padding: 0 110px 0 20px;
        width: auto;
        flex-basis: content
      }
    }
  }

  &--headlines {

    display: flex;
    +desktop() {
      margin-left: 123px
    }

    div {
      padding: 0;
      margin: 0;
      flex-grow: 0;
      flex-shrink: 0;
    }

    time {
      display: flex;
      font-weight: bold;
      background: white;
      align-items: center;
      justify-content: center;
      padding: 0 14px 0 2px;
      border-right: 2px solid black;
      flex-grow: 0;
      flex-shrink: 0;
    }
  }
}
</style>
